/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SafetyTypeDto } from '../../models/safety-type-dto';

export interface GetSafetyTypes$Params {
}

export function getSafetyTypes(http: HttpClient, rootUrl: string, params?: GetSafetyTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SafetyTypeDto>>> {
  const rb = new RequestBuilder(rootUrl, getSafetyTypes.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SafetyTypeDto>>;
    })
  );
}

getSafetyTypes.PATH = '/safeties/safety-types';
